import React, {useEffect, useRef, useState} from "react";
import DataTable from 'react-data-table-component'
import {Link} from "react-router-dom";
import axios from "axios";
import {Button, Col, Form, Modal, Row, Spinner, Table} from "react-bootstrap";
import {Trash, Edit, Eye, Tool, Layers} from 'react-feather';
import { websetting} from "../../../helpers/websetting";
import {SystemSetting} from "../../../constants/system";
import {useTranslation} from "react-i18next";

function SetupSevrices(){
    const t= useTranslation()
    const [validated, setValidated] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingModal, setLoadingModal] = useState(false);

    const [show, setShow] = useState(false);
    const [info, setInfo] = useState(true);
    const [infoData, setInfoData] = useState({});
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(SystemSetting.rowInPage);

    const handleClose = () => {
        setShow(false);
        setValidated(false);
        setInfo(true);
        setLoadingModal(false)
        setInfoData({})
    }

    const handleShow = () => {
        setShow(true);
    }



    const handleSubmit = (event: any) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        if (form.checkValidity() === true) {
            event.preventDefault();
            setLoadingModal(true)
            const PKid = event.target.Id.value;
            if(event.target.Id.value > 0){

                const formData = new FormData(event.target);
                if(event.target.uploadImage.value != ""){
                    const file = event.target.uploadImage.files[0];
                    formData.append('imageUrl', file, file.name);
                }

                formData.append('description', event.target.Description.value);
                formData.append('name', event.target.name.value);
                formData.append('nameAr', event.target.nameAr.value);
                formData.append('nameHe', event.target.nameHe.value);
                formData.append('orderBy', event.target.orderBy.value);

                axios.put(websetting.apiUrl + '/setup-service/api/v1/stpServices/'+event.target.Id.value,
                    formData,
                    {
                        method: "put",
                        headers: {
                            'Accept-Language':localStorage.getItem("lang") as string,
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    if(response.data.message != null){
                        alert(response.data.message)
                        setLoadingModal(false)
                        return
                    }
                     const index = data.findIndex( (array) => {
                        return parseInt(array["stpServiceIdPk"]) === parseInt(PKid)
                     });

                    let prevState = JSON.parse(JSON.stringify(data));
                    prevState[index].name = response.data.name
                    prevState[index].description = response.data.description
                    prevState[index].code = response.data.code

                    setData(prevState)
                    setShow(false)
                    setLoadingModal(true)

                }).catch(function (error) {
                    setLoadingModal(true)
                });
            }else {

                const formData = new FormData(event.target);
                if(event.target.uploadImage.value != ""){
                    const file = event.target.uploadImage.files[0];
                    formData.append('imageUrl', file, file.name);
                }

                formData.append('code', event.target.Code.value);
                formData.append('description', event.target.Description.value);
                formData.append('name', event.target.name.value);
                formData.append('nameAr', event.target.nameAr.value);
                formData.append('nameHe', event.target.nameHe.value);
                formData.append('orderBy', event.target.orderBy.value);

                axios.post(websetting.apiUrl + '/setup-service/api/v1/stpServices/',
                    formData,
                    {
                        method: "post",
                        headers: {
                            'Accept-Language':localStorage.getItem("lang") as string,
                            'content-type': 'application/json',
                            'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                        }
                    }
                ).then(async function (response) {
                    if(response.data.message != null){
                        alert(response.data.message)
                        setLoadingModal(false)
                        return
                    }


                    setData(data.concat(response.data))
                    setShow(false)
                    setLoadingModal(true)
                }).catch(function (error) {
                    setLoadingModal(true)
                });

            }
        }
    };

    const del = (id:any) => {
        if(window.confirm('Are you sure you wish to delete this item?')) {
            axios.delete(websetting.apiUrl + '/setup-service/api/v1/stpServices/' + id,
                {
                    method: "delete",
                    headers: {
                        'Accept-Language':localStorage.getItem("lang") as string,
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                const newData = data.filter((array) => {
                    return array["stpServiceIdPk"] !== id
                });
                setData(newData)
            }).catch(function (error) {
            });
        }
    }

    const edit = (id:any) => {
        setShow(true);
        if(id > 0){
            setLoadingModal(true)

            axios.get(websetting.apiUrl + '/setup-service/api/v1/stpServices/'+id,
                {
                    method: "get",
                    headers: {
                        'Accept-Language':localStorage.getItem("lang") as string,
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
            }).catch(function (error) {
            });
        }
    }

    const showInfo = (id:any) => {
        setShow(true);
        setInfo(false);
        if(id > 0){
            setLoadingModal(true)
            axios.get(websetting.apiUrl + '/setup-service/api/v1/stpServices/'+id,
                {
                    method: "get",
                    headers: {
                        'Accept-Language':localStorage.getItem("lang") as string,
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                    }
                }
            ).then(async function (response) {
                setLoadingModal(false)
                setInfoData(response.data)
              }).catch(function (error) {
            });
        }
    }

    const columns = [
        {
            name: t.t("iot.global.name"),
            selector: (row : any) => row.name,
        },{
            name: t.t("iot.global.description"),
            selector: (row : any) => row.description,
        },{
            name: t.t("iot.global.actions"),
            cell : (row : any) => <div><Button variant={"outline-danger"} onClick={()=>del(row.stpServiceIdPk)} className={"rounded-circle"}><Trash size={15} /></Button> <Button onClick={()=>edit(row.stpServiceIdPk)}  variant={"outline-info"} className={"rounded-circle "}><Edit size={15} /></Button> <Button  variant={"dark"}  onClick={()=>showInfo(row.stpServiceIdPk)} className={"rounded-circle "}><Eye  size={15} /></Button> <Link to={"../ServiceUsed/"+row.stpServiceIdPk}    className={"btn btn-success  rounded-circle"}><Layers size={15} className={"mt-1"} /></Link></div>,
        }
    ];

    const fetchDta = async (page:any) => {
        setLoading(true);
        const p = page - 1
        axios.get(websetting.apiUrl + 'setup-service/api/v1/stpServices?pageNO='+p+'&pageSize='+SystemSetting.rowInPage,
            {
                method: "get",
                headers: {
                    'Accept-Language':localStorage.getItem("lang") as string,
                    'content-type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem("access_token")
                }
            }
        ).then(async function (response) {
            setData(response.data.data);
            setLoading(false);
            setTotalRows(response.data.recordsTotal)
        }).catch(function (error) {

        });
    };

    const handlePageChange = (page :any) => {
        fetchDta(page);
    };
    const handlePerRowsChange = async (newPerPage:any, page:any) => {
        fetchDta(page)
    };

    useEffect(() => {
        fetchDta(1); // fetch page 1 of users
    }, [localStorage.getItem("lang")]);

   const infos =  JSON.parse(JSON.stringify(infoData))

    return(
        <div className={""}>
            <div className="lightbox">
                <div className={""}>
                    <div className="pagetitle text-uppercase">
                        <div className={"d-flex justify-content-between"}>
                            <div className={"d-inline-flex"}>
                                <Tool className={"feather"} size={21} />
                                {t.t("iot.global.stpServicesTitle")}
                            </div>
                            <div className={"d-inline-flex align-content-end"}>
                                <Button  variant={"warning"} className={"text-uppercase bold"}  onClick={()=>edit(0)}>+ {t.t("iot.global.newStpService")}</Button>
                            </div>
                        </div>

                    </div>
                    <DataTable progressPending={loading}
                               pagination
                               paginationServer
                               paginationTotalRows={totalRows}
                               progressComponent ={<Spinner className={"my-5"} animation={"border"} variant={"warning"} title={"Please Wait"} />}
                               onChangeRowsPerPage={handlePerRowsChange}
                               onChangePage={handlePageChange} columns={columns} data={data} />


                </div>
            </div>

            <Modal size={"xl"} centered={true}
                   show={show}
                   onExited={handleClose}
                   onHide={handleClose}
                   backdrop="static">
                <Modal.Header >
                    <Modal.Title><Tool className={"feather"} /> {t.t("iot.global.stpServicesTitle")}</Modal.Title>
                </Modal.Header>
                <Form noValidate validated={validated}  onSubmit={handleSubmit}>
                <Modal.Body>
                    {info ?
                        <div>{
                            loadingModal ? <div className={"text-center my-3"}><Spinner animation={"border"} variant={"danger"} /></div> :

                        <Row>
                            <Form.Group hidden controlId="Id" >
                                <Form.Control type={"hidden"}   value={infos.stpServiceIdPk}  />
                            </Form.Group>
                            <Col md={4}>
                                <Form.Group className="my-2" controlId="name" >
                                    <Form.Label>{t.t("iot.global.name")} En:</Form.Label>
                                    <Form.Control type="text"   defaultValue={infos.name}  required aria-label={t.t("iot.global.name")} aria-describedby="msgInput1" />
                                    <Form.Control.Feedback type="invalid"  id="msgInput1" >
                                        Required Field
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="my-2" controlId="nameHe" >
                                    <Form.Label>{t.t("iot.global.name")} He:</Form.Label>
                                    <Form.Control type="text"   defaultValue={infos.nameHe}  required aria-label={t.t("iot.global.name")} aria-describedby="msgInput1" />
                                    <Form.Control.Feedback type="invalid"  id="msgInput1" >
                                        Required Field
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="my-2" controlId="nameAr" >
                                    <Form.Label>{t.t("iot.global.name")} Ar:</Form.Label>
                                    <Form.Control type="text"   defaultValue={infos.nameAr}  required aria-label={t.t("iot.global.name")} aria-describedby="msgInput1" />
                                    <Form.Control.Feedback type="invalid"  id="msgInput1" >
                                        Required Field
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group className="my-2" controlId="orderBy" >
                                    <Form.Label>orderBy:</Form.Label>
                                    <Form.Control type="text"   defaultValue={infos.orderBy}  required aria-label={"orderBy"} aria-describedby="msgInput1" />
                                    <Form.Control.Feedback type="invalid"  id="msgInput1" >
                                        Required Field
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>



                            {!infos.stpServiceIdPk &&
                            <Col md={6}>
                                <Form.Group className="my-2" controlId="Code">
                                    <Form.Label>{t.t("iot.global.code")}:</Form.Label>
                                    <Form.Control type="text" defaultValue={infos.code} required
                                                  aria-label={t.t("iot.global.code")} aria-describedby="msgInput2"/>
                                    <Form.Control.Feedback type="invalid" id="msgInput2">
                                        Required Field
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            }

                            <Col md={12}>
                                <Form.Group className="my-2" controlId="uploadImage">
                                    <Form.Label>{"Upload Image"}:</Form.Label>
                                    <Form.Control  type={"file"} aria-label={"Upload Image"} />
                                </Form.Group>
                            </Col>

                            <Col lg={12}>
                                <Form.Group className="my-2" controlId="Description" >
                                    <Form.Label>{t.t("iot.global.description")}:</Form.Label>
                                    <Form.Control as={"textarea"} style={{ height: '80px' }} defaultValue={infos.description}  aria-label={t.t("iot.global.description")}    aria-describedby="msgInput3" />
                                    <Form.Control.Feedback type="invalid"  id="msgInput3" >
                                        Required Field
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        }
                        </div>
                        :
                        <div>
                        {
                            loadingModal ? <div className={"text-center my-5"}><Spinner animation={"border"} variant={"danger"} /></div> :
                                <div>
                                    <Table     hover>
                                        <tbody>
                                        <tr><td>Id</td><td>{infos.stpServiceIdPk}</td></tr>
                                        <tr><td>{t.t("iot.global.name")}</td><td>{infos.name}</td></tr>
                                        <tr><td>{t.t("iot.global.description")}</td><td>{infos.description}</td></tr>
                                        <tr><td>{t.t("iot.global.code")}</td><td>{infos.code}</td></tr>
                                        <tr><td>{t.t("iot.global.createdBy")}</td><td>{infos.createdBy}</td></tr>
                                        <tr><td>{t.t("iot.global.subscribeGateway")}</td><td>{infos.subscribeGateway}</td></tr>
                                        <tr><td>{t.t("iot.global.createdDate")}</td><td>{infos.createDate}</td></tr>
                                        <tr><td>{t.t("iot.global.updatedDate")}</td><td>{infos.updateDate}</td></tr>
                                        </tbody>
                                    </Table>
                                </div>
                        }
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" className={"text-uppercase"} onClick={handleClose}>{t.t("iot.global.close")}</Button>
                    {info &&  <Button type={"submit"} className={"text-uppercase"}  variant="warning">{t.t("iot.global.save")}</Button>}

                </Modal.Footer>
                </Form>
            </Modal>

        </div>
    )
}
export default SetupSevrices;
